import { Image } from '@unistocks/components/basic/image';
import { SharedPortfolioDto } from '@unistocks/proxy/axios-client';
import { SelectOption } from '@unistocks/types';
import React from 'react';

export const mapSharedPortfolioToOption = (
  portfolio: SharedPortfolioDto
): SelectOption<SharedPortfolioDto> => ({
  key: portfolio.portfolioName!,
  title: portfolio.portfolioName,
  subTitle: portfolio.userName,
  value: portfolio,
  icon: portfolio.userProfilePictureUri
    ? ({ size }) => (
        <Image rounded size={size} source={portfolio.userProfilePictureUri!} />
      )
    : undefined
});
